module.exports = __webpack_public_path__ + "img/4.144d3f17.jpg";